
import {defineComponent} from 'vue';
import SiteForm from "@/components/form/SiteForm.vue";
import FungusRecordForm from "@/components/form/FungusRecordForm.vue";
import Message from "primevue/message";
import Button from "primevue/button";
import FormLegend from "@/components/legend/FormLegend.vue";
import {scrollToTop} from "@/config/app-settings";

export default defineComponent({
  components: {FormLegend, FungusRecordForm, SiteForm, Message, Button},
  name: 'Form',
  data() {
    return {
      state: 'init' as 'init' | 'submitted' | 'success' | 'error',
      cancelRequested: false,
      submitAnswer: '' as string,
    }
  },
  computed: {
    fungusRecordForm(): Object {
      return this.$store.state.fungusRecordForm
    },
    isValid(): Boolean {
      return this.$store.getters.recordsAreValid && this.$store.getters.siteIsValid
    }
  },
  methods: {
    initializeForm() {
      if (this.$store.state.formState == 'new') {
        this.$store.dispatch('validate', {})
        this.$store.dispatch('newFungusRecord')
        this.$store.commit('setFormState', 'editingUnsaved')
      } else {
        this.$store.commit('setFormState', 'editing')
      }
    },
    submit() {
      console.log("state.fungusRecordForm ", this.$store.state.fungusRecordForm)

      this.$store.dispatch('submitFungusRecordForm')
          .then((res: string) => {
            this.submitAnswer = res
            this.$store.dispatch('notify', res.toString())
            this.$store.dispatch('validate', {})
            this.$router.push({name: 'Home'})
            this.state = 'success'
            this.$store.commit('setFormState', 'new')
            this.$store.state.menubarClicked = false

          })
          .catch((err: any) => {
            this.state = 'error'
            console.log("err.response.data", err.response.data)
            this.$store.dispatch('validate', err.response.data)
          })
    }
    ,
    cancel() {
      this.$router.push({name: 'Home'})
      this.$store.dispatch('deleteFungusRecordForm')
      this.$store.dispatch('validate', {})
      this.cancelRequested = false
      this.$store.state.menubarClicked = false
      this.$store.commit('setFormState', 'new')
    },
  },
  beforeMount() {
    scrollToTop()
    this.initializeForm()
  }
});
